


























































import { Component, Prop, Vue } from 'vue-property-decorator';
import axios from 'axios';
import JournalDetailsComponent from './JournalDetailsComponent.vue';
import moment from 'moment';
import { i18n, translate } from './../i18n';
import { TYPES } from '@/ioc/Types';
import { ActaService } from '@/services/ActaService';
import { lazyInject } from '@/ioc/DIContainer';

@Component({
  components: {
    JournalDetailsComponent
  }
})
export default class PostJournalComponent extends Vue {
  @Prop() private tenantId!: string;
  @Prop() private tenantName!: string;
  @Prop() private selectedLocale!: any;
  @lazyInject(TYPES.ActaService)
  private actaService!: ActaService;
  archiveParts: any[] = [];
  selectedArchivePartId: string = '00000000-0000-0000-0000-000000000000';
  dataTableheight: number = 0;
  documents: any[] = [];
  isLoading: boolean = false;
  showDetails: boolean = false;
  modalData: any = { visible: false };
  fromDate: moment.Moment = moment(new Date()).add(-100, 'days');
  toDate: moment.Moment = moment(new Date());
  pdfData: any = '';
  emptyTextCustomize = true
  columns = [
    {
      title: `${translate('post_journal_list.th_document_number')}`,
      scopedSlots: { customRender: 'name' },
      dataIndex: 'Identificator'
      // width: '10%'
    },
    {
      title: `${translate('post_journal_list.th_document_date')}`,
      scopedSlots: { customRender: 'date' },
      dataIndex: 'DocumentDate'
      // width: '10%'
    },
    {
      title: `${translate('post_journal_list.th_document_name')}`,
      scopedSlots: { customRender: 'doc_title' },
      dataIndex: 'Title'
      // width: '10%'
    },
    {
      title: `${translate('post_journal_list.th_parties')}`,
      dataIndex: 'Parties'
      // width: '10%'
    },
    {
      title: `${translate('post_journal_list.th_document_type')}`,
      scopedSlots: { customRender: 'type' },
      dataIndex: 'RecordType.Code'
      // width: '10%'
    },
    {
      title: `${translate('post_journal_list.th_record_date')}`,
      scopedSlots: { customRender: 'date' },
      dataIndex: 'RecordDate'
      // width: '10%'
    },
    {
      title: `${translate('post_journal_list.th_description')}`,
      dataIndex: 'Description'
      // width: '10%'
    },
    {
      title: `${translate('post_journal_list.th_responsible')}`,
      dataIndex: 'RecordResponsible'
      // width: '10%'
    },
    {
      title: `${translate('post_journal_list.th_screening_code')}`,
      dataIndex: 'ScreeningCode.Code'
      // width: '10%'
    },
    {
      title: `${translate('post_journal_list.th_class_code')}`,
      dataIndex: 'ClassCode'
    }
  ];

  mounted () {
    // this.getPostJournal();
    this.dataTableheight = window.innerHeight - 300;
    this.actaService.getArchiveParts(this.tenantId, this.archivePartsFetched, this.archivePartsFetchError);
  }
  archivePartsFetched (response: any) {
    if (response.data) {
      if (response.data.Entities) {
        this.archiveParts = response.data.Entities;
        const all: any = {
          Id: '00000000-0000-0000-0000-000000000000',
          Title: `${translate('post_journal_list.archives_all')}`
        };
        this.archiveParts.unshift(all);
      }
    }
    this.isLoading = false;
  }

  archivePartsFetchError () {
    this.isLoading = false;
    this.$notification['error']({
      message: 'Error',
      description: 'Error occurred',
      duration: 5
    });
  }

  async getPostJournal () {
    this.documents = [];
    this.isLoading = true;
    this.actaService.getPostJournalRecords(this.tenantId, this.fromDate, this.toDate, this.selectedArchivePartId, this.dataFetched, this.fetchError);
  }

  dataFetched (response: any) {
    this.emptyTextCustomize = false;
    if (response.data) {
      if (response.data.Entities) {
        this.documents = response.data.Entities;
      }
    }
    this.isLoading = false;
  }
  openDetails (document: any) {
    let doc = this.documents.findIndex((x: any) => {
      return x.Identificator === document;
    });
    if (doc !== -1) {
      this.modalData.tenantId = this.tenantId;
      this.modalData.document = this.documents[doc];
      this.modalData.visible = true;
    }
  }

  formatDate (date: Date) {
    return moment(date).format('L');
  }

  fetchError () {
    this.emptyTextCustomize = false;
    this.isLoading = false;
    this.$notification['error']({
      message: 'Error',
      description: 'Error occurred',
      duration: 5
    });
  }
  download() {
    let req = {
      RecordsCount: this.documents.length,
      StartDate: moment(this.fromDate).format('L'),
      EndDate: moment(this.toDate).format('L'),
      Name: this.tenantName,
      PrintedDate: moment(this.toDate).format('L') + ', ' + moment(this.toDate).format('LT'),
      Records: JSON.parse(JSON.stringify(this.documents))
    };
    req.Records = req.Records.map((rec: any) => {
      const record = { ...rec, DocumentDateText: moment(rec.DocumentDate).format('L'), RecordDateText: moment(rec.RecordDate).format('L'), Title: rec.Title ? rec.Title : rec.PublicTitle + ` ${translate('common.title_screened')}` };
      return (
        record
      );
    });
    this.isLoading = true;
    this.actaService.getPostjournalReport(this.tenantId, req, this.postedData, this.fetchError, this.selectedLocale.locale === 'no' || this.selectedLocale.locale === 'nb' ? 'nb-NO' : 'en-US');
  };
  postedData (response: any) {
    const fileName = `${translate('common.postjournal_title')}` + '_' + this.fromDate.format('DD.MM.YYYY') + '_' + `${translate('common.to')}` + '_' + this.toDate.format('DD.MM.YYYY') + '.pdf';
    this.pdfData = response.data.ResponseValue;
    this.isLoading = false;

    const linkSource = `data:application/pdf;base64,${this.pdfData}`;
    const downloadLink = document.createElement('a');
    document.body.appendChild(downloadLink);
    downloadLink.href = linkSource;

    downloadLink.target = '_self';
    downloadLink.download = fileName;
    downloadLink.click();
    this.isLoading = false;
    setTimeout(function() {
      document.body.removeChild(downloadLink);
      window.URL.revokeObjectURL(linkSource);
    }, 0);
  }
  disableDownloadButton() {
    if (this.documents) {
      return this.documents.length === 0;
    } else {
      return true;
    }
  }
}
